"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const preact_1 = require("preact");
const hooks_1 = require("preact/hooks");
const preact_custom_element_1 = __importDefault(require("preact-custom-element"));
const filter_1 = __importDefault(require("../../hooks/filter"));
const pagination_1 = __importDefault(require("../../hooks/pagination"));
const filter_2 = __importDefault(require("./filter"));
const card_1 = __importDefault(require("./card"));
const navigation_1 = __importDefault(require("./navigation"));
function RecipesGrid({ recipes, taxonomies, initialPage = 1, itemsPerPage }) {
    const id = (0, hooks_1.useId)();
    const gridRef = (0, hooks_1.useRef)(null);
    const filter = (0, filter_1.default)(recipes, taxonomies);
    const pagination = (0, pagination_1.default)({
        initialPage,
        itemsPerPage,
        itemsCount: filter.items.length,
    });
    const scrollToTop = (0, hooks_1.useCallback)(() => {
        var _a;
        (_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            behavior: 'smooth',
        });
    }, []);
    (0, hooks_1.useEffect)(() => {
        pagination.setCurrentPage(1);
    }, [filter.selection]);
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("form", { className: 'wrapper  filters  recipes-page__filters  fg-red  font-veneer  tracking-wide  page__padding' },
            (0, preact_1.h)("h2", null, "Show recipes by"),
            (0, preact_1.h)("div", { className: 'filters__controls' }, taxonomies.map((taxonomy) => ((0, preact_1.h)(filter_2.default, { key: taxonomy.slug, namespace: id, filter: filter, taxonomy: taxonomy }))))),
        (0, preact_1.h)("div", { ref: gridRef, className: 'card-grid' }, pagination.paginate(filter.items).map((recipe) => ((0, preact_1.h)(card_1.default, { key: recipe.slug, recipe: recipe })))),
        (0, preact_1.h)(navigation_1.default, Object.assign({ scrollToTop: scrollToTop }, pagination))));
}
exports.default = RecipesGrid;
function RecipesGridComponent({ recipes, taxonomies, initialPage, itemsPerPage }) {
    return ((0, preact_1.h)(RecipesGrid, { recipes: JSON.parse(recipes), taxonomies: JSON.parse(taxonomies), initialPage: Number(initialPage), itemsPerPage: Number(itemsPerPage) }));
}
(0, preact_custom_element_1.default)(RecipesGridComponent, 'sarsons-recipe-grid');
